module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.rejectedItems.length) ? _c('MentoringRequestList', {
    attrs: {
      "items": _vm.rejectedItems
    }
  }) : _c('Warning', [_c('p', [_vm._v(_vm._s(_vm.warningText))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132d7c45","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/views/rejectedrequests/MentoringRejectedRequests.vue
// module id = 331ea86e2b060e29e705
// module chunks = 68